import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AcademyCourtService } from 'src/app/services/academyCourt.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import {
  SwiperComponent,
  SwiperDirective,
  SwiperConfigInterface,
  SwiperScrollbarInterface,
  SwiperPaginationInterface
} from 'ngx-swiper-wrapper';
@Component({
  selector: 'app-court-types',
  templateUrl: './court-types.component.html',
  styleUrls: ['./court-types.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class CourtTypesComponent implements OnInit {
  public showingForm: boolean = false;
  courttypesform: FormGroup;
  submitted = false;
  public courtTypeList = environment.courtTypeList;
  imageSize = environment.imageSize;
  uploadedFiles: any[] = [];
  pagetitle: string;
  isAddMode: boolean;
  academyId: string;
  courtImage: any;
  courtlist: any;
  public loading: boolean;
  errorMessage = '';
  public selectedcourtType;
  loggedInAcademy;
  loggedInAcademyId;
  item: any;
  typeid: any;
  courtimage: any;
  showUploadedpic: boolean = false;
  public court_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',

    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    mousewheel: false,
    slidesPerView: 'auto',
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    },
    navigation: false,
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  };
  public disabled: boolean = false;
  constructor(private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private tokenStorage: TokenStorageService,
    private academyCourtService: AcademyCourtService,
    private router: Router,
    private route: ActivatedRoute,) { }

  ngOnInit(): void {
    this.loggedInAcademy = this.tokenStorage.getUser();
    this.loggedInAcademyId = this.loggedInAcademy.userdata['academyId'];
    let academyPaymentDetails = this.loggedInAcademy.userdata.academyPaymentDetails;
    let roleName = this.loggedInAcademy.userdata.rolename;
    let currentUrl = '/';
    if (roleName == "academy") {
      if (Object.keys(academyPaymentDetails).length > 0) {
        if (academyPaymentDetails.academyPaymentStatus == 'created') {
          currentUrl = '/payment-history';
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate([currentUrl]);
        }
      } else {
        currentUrl = '/payment-history';
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
      }
    }
    this.courttypesform = this.formBuilder.group({
      courtType: ['', [Validators.required]],
    }, { updateOn: "blur" });
    this.loadCourt();
  }
  get f() {
    return this.courttypesform.controls;
  }

  openmodal() {
    this.showingForm = false;
    this.pagetitle = 'Add Court';
    this.uploadedFiles = [];
    this.courtimage = '';
    this.showUploadedpic = false;
    this.isAddMode = true
    this.submitted = false;
    this.courttypesform.reset();
    this.showingForm = true;
  }
  onHighlightModalClose() {
    this.isAddMode = true;
    this.showingForm = false;

  }
  onClickEdit(id) {
    this.pagetitle = 'Edit Court';
    this.isAddMode = false;
    this.showingForm = true;
    this.getcourtdetails(id)
  }

  getcourtdetails(id) {
    this.academyCourtService.getAcademyCourtDetails(id).subscribe(res => {
      this.item = res;
      this.typeid = id;
      if (this.item['courtType']) {
        this.courtTypeList.forEach(element => {
          if (element.value == this.item['courtType']) {
            this.courttypesform.controls.courtType.setValue({ label: element.label, value: element.value });
          }
        })
      }
      if (this.item['image'] != undefined) {
        this.courtimage = this.item['image'];
        this.showUploadedpic = true;
      } else {
        this.showUploadedpic = false;
      }
    })
  }
  loadCourt() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.loggedInAcademyId;
    this.academyCourtService.getAcademyCourtList(query).subscribe(
      data => {
        this.loading = false;
        if (data.data.items.length > 0) {
          this.courtlist = data.data.items;
          this.courtlist.forEach(dt => {
            let tmp = this.courtTypeList.find(o => o.value === dt.courtType);
            if (tmp != undefined) {
              dt.court = tmp.label;
            } else {
              dt.court = '';
            }
          })
        }
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  picUploader(event) {
    // console.log("uploadimage",event.file);
    let index = 0;
    for (let file of event.files) {
      this.uploadedFiles.push(file);
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // called once readAsDataURL is completed
        if (reader.result != null) {
          this.courtImage = reader.result;
        }
      }
    }
  }
  onCourtSelect(event) {
    this.selectedcourtType = event.value.value;
  }
  onsubmit() {
    this.submitted = true;
    if (this.courttypesform.invalid) {
      //console.log("invalid");
      return;
    }
    var courttypeData = this.courttypesform.value
    courttypeData['courtImage'] = this.courtImage;
    courttypeData['academyId'] = this.loggedInAcademyId;
    courttypeData['status'] = true;
    courttypeData['disable'] = false;
    delete courttypeData['courtType']
    if (this.isAddMode) {
      courttypeData['selectedcourtType'] = this.selectedcourtType;
      courttypeData = JSON.stringify(courttypeData, null, 4);
      this.addCourt(courttypeData);
    } else {
      courttypeData['courtType'] = this.selectedcourtType;
      courttypeData = JSON.stringify(courttypeData, null, 4);
      this.updateCourt(courttypeData);
    }
  }

  addCourt(courttypeData) {
    this.academyCourtService.addAcademyCourt(courttypeData).subscribe(
      () => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Academy Court data Added', life: 6000 });
        setTimeout(() => {
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate(['academies-profile/courts']);
        }, 200);
        this.uploadedFiles = [];
        this.courtimage = '';
        this.showingForm = false;
        this.submitted = false;
        this.onHighlightModalClose();
        this.courttypesform.reset();
        //this.loadCourt();
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add Academy Court data failed', life: 6000 });
        this.onHighlightModalClose();
        this.courttypesform.reset();
      })
    );
  }
  updateCourt(courttypeData) {
    this.academyCourtService.updateAcademyCourt(this.typeid, courttypeData).subscribe(
      () => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Academy Court data Updated', life: 6000 });
        setTimeout(() => {
          this.router.navigate(['/academies-profile/courts']);
        }, 2000);
        // this.courtimage = '';
        // this.uploadedFiles = [];
        this.onHighlightModalClose();
        this.courttypesform.reset();
        this.loadCourt();
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update Academy Court data failed', life: 6000 });
        this.onHighlightModalClose();
        this.courttypesform.reset();
        this.loadCourt();
      })
    );
  }
  onClickDelete(data) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this court?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let disableStatus;
        if (data.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        let updatedata = '{"disable":' + disableStatus + '}';
        this.academyCourtService.updateAcademyCourt(data.id, updatedata).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Court type Deleted', life: 3000 });
            this.loadCourt();
          },
          err => {
            this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: 'System Error. Please try again.', life: 3000 });
          }
        );
      },
      reject: () => {
        //this.getUserDetails(user.id);
      }
    });
  }


  public onIndexChange(index: number): void {
    //console.log('Swiper index: ', index);
  }

  public onSwiperEvent(event: string): void {
    //console.log('Swiper event: ', event);
  }

  public toggleKeyboardControl(): void {
    this.court_config.keyboard = !this.court_config.keyboard;
  }

  public toggleMouseWheelControl(): void {
    this.court_config.mousewheel = !this.court_config.mousewheel;
  }
}
